import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import { LuAirplay, LuBird, LuHouse, LuPackageOpen, LuPlane, LuWorkflow } from 'react-icons/lu'

const SERVICES = [
  {
    icon: <LuPlane color='white' strokeWidth={'1.2px'}/> ,
    tag: 'Premium',
    title: 'Transport des animaux vivants',
    desc: "Nous assurons le transport de votre animal dans des conditions optimales de sécurité et de confort. Nos cages répondent aux normes internationales en vigeur. La température est controlée en continu pendant tout le trajet. Nous fournissons l'intégralité de la documentation requise.",
    features: ['Cage homologuées', 'Gestion documentaire complète', 'Controle thermique permanent'],
    color: 'gold',
  },
  {
    icon: <LuPackageOpen strokeWidth={'1.2px'} />,
    tag: 'Professionnel',
    title: 'Expédition des colis',
    desc: "Nous assurons le transport de vos colis vers toutes destinations. Chaque envoi bénéficie d'emballage adapté et sécurisé. La température est controlée en continu pour les marchandises sensibles. Nous fournissons l'intégralité de la documentation douanière et de suivi.",
    features: ['Emballage sécurisé sur mesure', 'Contrôle thermique permanent', 'Gestion documentaire complète'],
    color: 'navy',
  },
  {
    icon: <LuBird strokeWidth={'1.2px'} />,
    tag: 'Particuliers',
    title: 'Suivi en temps réel des animaux',
    desc: "Notre plateforme professionnelle vous donne accès à la localisation précise de vos animaux pendant le transport. Vous recevrez des alertes personnalisées à chaque étape du parcours. Un historique détaillé et des rapports sont disponibles en téléchargement.",
    features: ['Suivi GPS en direct', 'Alertes automatiques par étape', 'Rapports et historique téléchargeables'],
    color: 'default',
  },
  {
    icon: <LuWorkflow strokeWidth={'1.2px'} />,
    tag: 'Entreprises',
    title: 'Suivi en temps réel des colis',
    desc: "Notre application vous permet de suivre l'acheminement de vos colis en temps réel. Des notifications sont envoyées à chaque étape clé (prise en charge, transit, livraison). Une photo du colis est fournie à la prise en charge et ç la livraison. Un service client est joignable 7 jours sur 7.",
    features: ['Notifications à chaque étape', 'Photo avant et après transport', 'Service client disponible 7j/7'],
    color: 'default',
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Services({ trackEvent }) {
  const handleServiceClick = (title) => {
    // Tracking : clic sur une carte service
    trackEvent('service_card_click', { service: title });
  };

  return (
    <section id="services" className="services" data-tracking-name="Services">
      <div className="services-container">
        {/* En-tête */}
        <motion.div
          className="services-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label">Ce que nous faisons</span>
          <h2 className="section-title">
            Des solutions sur-mesure<br />pour chaque voyage
          </h2>
          <p className="services-intro">
            Quatre offres pensées pour couvrir tous les besoins, des particuliers aux professionnels,
            avec un niveau d'exigence constant.
          </p>
        </motion.div>

        {/* Grille de cartes */}
        <div className="services-grid">
          {SERVICES.map((service, i) => (
            <motion.div
              key={service.title}
              className={`service-card service-card--${service.color}`}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              variants={cardVariants}
              whileHover={{ y: -6, transition: { duration: 0.3 } }}
              onClick={() => handleServiceClick(service.title)}
            >
              <div className="service-card-top">
                <span className="service-icon">{service.icon}</span>
                <span className="service-tag">{service.tag}</span>
              </div>

              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>

              <ul className="service-features">
                {service.features.map((f) => (
                  <li key={f}>
                    <span className="feature-check">✓</span>
                    {f}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
